import { useAppState } from '../AppContext';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Card, Spinner } from 'react-bootstrap';
import { GrContract } from 'react-icons/gr';
import { FaArrowLeft, FaFilePdf } from 'react-icons/fa';
import { clusterColor, getDisplayName } from './utils';
import { GiPlainCircle } from 'react-icons/gi';

import './DocumentList.css';
import './CustomButton.css';

const RelatedDocumentLi = ({ document, highlightSnippet, itemNumber }) => {
  let [
    { selectedDocument, documentCluster, clusterLabels, documentClusterObj }
  ] = useAppState();

  const cluster_id = documentCluster[document.id];
  const color = clusterColor(documentClusterObj[document.id]);

  return (
    <>
      <div style={{ 'margin-right': '1em' }}>
        <GiPlainCircle color={color} />
      </div>

      <div>
        <span style={{ 'margin-left': '-1em' }}>{itemNumber}.</span>{' '}
        {document && (
          <span style={{ fontWeight: 'bold' }}>{getDisplayName(document)}</span>
        )}
        <br />
        <span style={{ fill: color }} className="keywords">
          {clusterLabels[cluster_id]}
        </span>
        <br />
        <Button
          onClick={() => highlightSnippet(null, document)}
          variant="custom"
          size="sm"
        >
          <FaArrowLeft
            color={document.id === selectedDocument.id ? 'gold' : 'black'}
          />{' '}
          View
        </Button>{' '}
        <a
          href={`/api/uploads/${document.id}/${document.filename}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFilePdf title={'Open PDF of this document'} color="grey" />
        </a>
      </div>
    </>
  );
};

RelatedDocumentLi.propTypes = {
  document: PropTypes.shape({
    id: PropTypes.number.isRequired,
    filename: PropTypes.string
  }),
  highlightSnippet: PropTypes.func,
  itemNumber: PropTypes.number.isRequired
};

const RelatedDocumentsList = ({ document_id, highlightSnippet }) => {
  const [{ selectedDocument, searchString }, dispatch] = useAppState();

  const [relatedDocuments, setRelatedDocuments] = useState([]);
  const [loadingRelatedDcouments, setLoadingRelatedDocuments] = useState(false);

  useEffect(() => {
    setLoadingRelatedDocuments(true);
    fetch('/nlp/documents/similar', {
      method: 'POST', // or 'PUT'
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        method: 'solr',
        documentId: document_id,
        numRows: 5,
        textQuery: searchString,
        includeSnippets: false
      })
    })
      .then((response) => response.json())
      .then((data) => {
        setLoadingRelatedDocuments(false);
        console.log('Success:', data);
        const docs = data.documents.filter((doc) => doc.id !== document_id);
        docs.sort((a, b) => b.score - a.score);

        setRelatedDocuments(docs);
        //   setRelatedDocuments(docs.filter(documentFilter));   // TODO: filter based on filter metadata
      })
      .catch((error) => {
        setLoadingRelatedDocuments(false);
        console.error('Error on search:', error);
      });
  }, [document_id, searchString]);

  return (
    <Card border="info" key={document_id} style={{ marginTop: '10px' }}>
      <Card.Header
        style={{
          backgroundColor:
            selectedDocument && selectedDocument.id === document_id
              ? 'rgba(255, 215, 0, 0.2)'
              : null
        }}
      >
        &nbsp;
        <Button
          variant="light"
          size="sm"
          onClick={() =>
            dispatch({
              type: 'SET_SHOW_RELATED_DOCS',
              documentId: document_id,
              value: false
            })
          }
        >
          <GrContract /> Hide
        </Button>
      </Card.Header>

      <Card.Body>
        {loadingRelatedDcouments && (
          <p>
            Searching for related documents...
            <Spinner
              as="span"
              animation="border"
              role="status"
              aria-hidden="true"
            />
          </p>
        )}

        <div
          style={{
            display: 'grid',
            'grid-template-columns': '2em calc(100% - 2em)',
            'grid-gap': '10px'
          }}
        >
          {!loadingRelatedDcouments &&
            relatedDocuments &&
            relatedDocuments.map((doc, i) => (
              <RelatedDocumentLi
                key={doc.id}
                document={doc}
                highlightSnippet={highlightSnippet}
                itemNumber={i + 1}
              />
            ))}
        </div>
      </Card.Body>
    </Card>
  );
};

RelatedDocumentsList.propTypes = {
  document_id: PropTypes.number,
  highlightSnippet: PropTypes.func
};

export default RelatedDocumentsList;
